import React, { useEffect, Fragment } from 'react';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../../../../../constants/text';
import { colors } from '../../../../../../constants/colors';
import withTileAction from '../../util/withTileAction';
import {
  INSURANCE_SWIMLANE_COPAY_COINSURANCE_TAPPED,
  INSURANCE_COPAY_COINSURANCE_DETAILS_MODAL_OPENED,
} from '../../../../../../core/analytics/events';

import { useCopayCoinsuranceStepCopy } from '../../../../../Account/Profile/Insurance/util/insuranceDetails';
import { getQueryParams } from '../../../../../../core/util/url';
import { URGENT_CARE_VALUE } from '../../../../../Home/Tiles/ProviderTypes';

const Root = styled.div.withConfig({ componentId: 'sc-15k1szi-0' })`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 269px;
  cursor: pointer;
  letter-spacing: 0.25px;
  line-height: 21px;
`;

const Header = styled.div.withConfig({ componentId: 'sc-15k1szi-1' })`
  width: 100%;
  padding-bottom: 15px;
  border-bottom: 1px solid ${colors.granite};
  text-align: center;
  max-height: 74px;
`;

const Icon = styled.img.withConfig({ componentId: 'sc-15k1szi-2' })`
  width: 45%;
  max-height: 55px;
  object-fit: contain;
`;

const Title = styled.div.withConfig({ componentId: 'sc-15k1szi-3' })`
  color: ${colors.darkText};
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.medium};
`;

const PurpleBar = styled.div.withConfig({ componentId: 'sc-15k1szi-4' })`
  height: 4px;
  width: 100%;
  background-color: ${colors.purpSizzurp};
  border-radius: 8px 8px 0 0;
  margin-bottom: 15px;
`;

const Flex = styled.div.withConfig({ componentId: 'sc-15k1szi-5' })`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 8px;
  border-bottom: 1px solid ${colors.granite};
  padding-bottom: 10px;
`;

const Row = styled.div.withConfig({ componentId: 'sc-15k1szi-6' })`
  display: flex;
  justify-content: space-between;
  color: ${colors.blueMonday};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  padding: 5px 12px;
  width: 85%;
  margin: 5px auto;
  border-radius: 4px;
  line-height: 1.8em;
  opacity: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'ThemedStyled... Remove this comment to see the full error message
    props.sc && props.sc.isHighlightedRow ? '1' : '0.56'};
  background-color: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'ThemedStyled... Remove this comment to see the full error message
    props.sc && props.sc.isHighlightedRow ? colors.grayDim : colors.theWhiteAlbum};
`;

const RowTitle = styled(Row).withConfig({ componentId: 'sc-15k1szi-7' })`
  letter-spacing: 0.33px;
  line-height: 24px;
  margin: 15px auto 0;
  align-items: baseline;
  opacity: 1;
`;

const Pay = styled.div.withConfig({ componentId: 'sc-15k1szi-8' })`
  color: ${colors.darkText};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.small};
  opacity: 0.56;
  letter-spacing: 0.22px;
`;

const InOutNetworkContainer = styled.div.withConfig({ componentId: 'sc-15k1szi-9' })`
  margin-top: 0;
`;

const Footer = styled.div.withConfig({ componentId: 'sc-15k1szi-10' })`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  width: 85%;
  padding: 10px 0 17px;
  cursor: pointer;
`;

const Details = styled.div.withConfig({ componentId: 'sc-15k1szi-11' })`
  color: ${colors.blueJayWay};
  font-size: ${fontSize.default};
`;

const Arrow = styled(ArrowForwardIosIcon).withConfig({ componentId: 'sc-15k1szi-12' })`
  font-size: ${fontSize.small};
`;

const ComingSoon = styled.div.withConfig({ componentId: 'sc-15k1szi-13' })`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  font-style: italic;
  color: ${colors.blueMonday};
`;

type Props = {
  tile: any;
  tileIndex: number;
  userProfile?: any;
  eventName?: string;
  doTileAction?: (...args: any[]) => any;
  insuranceProfile?: any;
  insuranceDetails?: any;
};

const CopayCoinsuranceByService = (props: Props) => {
  const { tile, tileIndex, userProfile, insuranceDetails } = props;

  const shouldShowSeeMoreDetailsCta = () => tile.providerType === URGENT_CARE_VALUE;

  useEffect(() => {
    const queryParams = getQueryParams();
    if (queryParams.cost_estimate && shouldShowSeeMoreDetailsCta()) {
      // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      props.doTileAction(
        tileIndex,
        tile,
        userProfile,
        null,
        INSURANCE_COPAY_COINSURANCE_DETAILS_MODAL_OPENED
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { card: cardStepCopy } = useCopayCoinsuranceStepCopy(
    insuranceDetails,
    tile.providerType,
    true
  );

  if (!cardStepCopy) return null;

  return (
    <Root
      id={`copay-by-service-${tile.id}-${tileIndex}`}
      onClick={() =>
        // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        props.doTileAction(
          tileIndex,
          tile,
          userProfile,
          null,
          INSURANCE_SWIMLANE_COPAY_COINSURANCE_TAPPED
        )
      }
    >
      <PurpleBar />

      <Header>
        <Icon src={tile.icon} />
      </Header>

      <Flex>
        <RowTitle>
          <Title>{tile.title}</Title>

          <Pay>YOU'LL OWE</Pay>
        </RowTitle>

        <InOutNetworkContainer>
          {cardStepCopy.map((step: any, i: any) => (
            <Row
              data-testid={`copay-details-row-${i + 1}`}
              key={`${step.title}${step.value}`}
              // @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type 'IntrinsicAtt... Remove this comment to see the full error message
              sc={{ isHighlightedRow: step.isCurrentStep }}
            >
              <div>{step.title}</div>

              <div>{step.value}</div>
            </Row>
          ))}
        </InOutNetworkContainer>
      </Flex>

      <Footer>
        {shouldShowSeeMoreDetailsCta() ? (
          <>
            <Details>See benefit details</Details>

            <Arrow />
          </>
        ) : (
          <ComingSoon>Benefit details coming soon</ComingSoon>
        )}
      </Footer>
    </Root>
  );
};

export default withTileAction(CopayCoinsuranceByService);
